<template>
  <el-button
      @click="clickEvent"
      v-bind="$attrs"
      v-on="$listeners"
      :size="btnSize"
      :type="type"
      :class="{'gj-button--icon': type === 'icon',
       'gj-button--font14': font14,
       'gj-button--ghost': type === 'ghost',
       'gj-btn-iconfont': type === 'iconfont'
       }">
      <slot></slot>
      <i v-if="iconfont && (type === 'iconfont')" class="iconfont" :class="iconfont" :style="{'font-size': btnSize}"></i>
  </el-button>
</template>

<script>
  import {font14MixIn} from "../../minxins";
  import {sizeMap} from "../common";
  
  export default {
    name: "gj-button",
    mixins: [font14MixIn],
    props: {
      size: {
        type: String,
        default: 'default'
      },
      type: { //需要使用图标按钮可以使用 iconfont
        type: String,
        default: 'default'
      },
      iconfont: {
        type: String,
        default: ''
      }
    },
    computed: {
      btnSize() {
        return sizeMap[this.size] || this.size;
      }
    },
     methods: {
      //  点击按钮弹窗后，使其失焦
      clickEvent(e) {
      e.target.nodeName === 'BUTTON'  ? e.target.blur() : e.srcElement.parentNode.blur()
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';
  .el-button{
    font-weight: 400;
  }
  .gj-button--icon {
    height: 32px;
    width: 32px;
    padding: 0;
  }
  .el-button--text.el-button--mini.gj-button--font14 {
    font-size: 14px !important;
    border: none;
  }
  .gj-button--ghost:not(.is-disabled) {
    // background: #FFFFFF;
    border-color: $gj-button-border-color0;
    color: $gj-button-font-color1;
    outline: none;
    &:hover{
      background: $gj-button-background-color-hover1;
    }
  }
  .el-button--text.is-disabled,
  .el-button--text.is-disabled:focus,
  .el-button--text.is-disabled:hover {
    background: unset;
    border-color: transparent;
  }
  
  .el-button--text.is-disabled,
  .el-button--text.is-disabled:focus,
  .el-button--text.is-disabled:hover {
    background: unset;
    border-color: transparent;
  }
  .el-button--icon:hover{
    border-color: $gj-button-border-color0;
    background-color: $gj-button-background-color-hover1;
    /deep/ .gj-icon{
      color: $gj-button-font-color1;
    }
  }
  .is-disabled:hover{
    /* background: rgba(0, 0, 0, 0);
    border: 1px solid #ebeef5; */
  }
  .gj-btn-iconfont{
    padding: 0;
    border: none;
    border-radius: 50%;
    background: none;
  }
</style>
